import React, { useState } from 'react';

const FatalitiesForm = ({ onFormSubmit, incidentId }) => {
    const [name, setName] = useState('');
    const [cause, setCause] = useState('');
    const [date, setDate] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (name && cause && date) {
            setLoading(true);
            onFormSubmit && onFormSubmit({ name, cause, date }, incidentId);
            setName('');
            setCause('');
            setDate('');
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>
                    Name of Deceased:
                    <input
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        required
                    />
                </label>
            </div>
            <div>
                <label>
                    Cause of Fatality:
                    <input
                        type="text"
                        value={cause}
                        onChange={e => setCause(e.target.value)}
                        required
                    />
                </label>
            </div>
            <div>
                <label>
                    Date:
                    <input
                        type="date"
                        value={date}
                        onChange={e => setDate(e.target.value)}
                        required
                    />
                </label>
            </div>
            <button 
                type="submit" 
                disabled={loading}
                className={loading ? 'submit-button disabled' : 'submit-button'}
            >
                {loading ? "Submitting..." : "Submit"}
            </button>
        </form>
    );
};

export default FatalitiesForm;